import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';
import FormRadio from 'components/forms/FormRadio';

class AttributeData extends React.Component {
  changeEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;

    const newEntity = { ...entity.updateValue(propertyName, value) };

    changeEntity(newEntity);
  };

  isTypeChecked = type => {
    const { entity } = this.props;
    return entity.getType() === type;
  };

  typeChange = e => {
    const { target } = e;
    const type = target.value;

    this.changeEntity('type', type);
  };

  render() {
    const { intl, entityLoaded, entity, disabled, inModal } = this.props;
    const { messages } = intl;

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormLangInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.changeEntity}
                      disabled={disabled}
                    />
                    <FormLangRichEditor
                      label={messages.description}
                      name="description"
                      value={entity.getDescription()}
                      meta={entity.getDescriptionMetaInformation()}
                      validation={entity.getDescriptionValidationResult()}
                      onChange={this.changeEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.position}
                      name="position"
                      value={entity.getPosition()}
                      meta={entity.getPositionMetaInformation()}
                      validation={entity.getPositionValidationResult()}
                      onChange={this.changeEntity}
                      disabled={disabled}
                    />
                    <FormRadio
                      label={messages.required}
                      name="isRequired"
                      value={entity.getIsRequired()}
                      meta={entity.getIsRequiredMetaInformation()}
                      validation={entity.getIsRequiredValidationResult()}
                      onChange={this.changeEntity}
                      options={[{ value: false, label: messages.no }, { value: true, label: messages.yes }]}
                    />
                    <FormRadio
                      label={messages.multilanguage}
                      name="isMultilanguage"
                      value={entity.getIsMultilanguage()}
                      meta={entity.getIsMultilanguageMetaInformation()}
                      validation={entity.getIsMultilanguageValidationResult()}
                      onChange={this.changeEntity}
                      options={[{ value: false, label: messages.no }, { value: true, label: messages.yes }]}
                    />
                    <FormRadio
                      label={messages.perforation.attribute_is_custom_fa_setting}
                      name="isCustomFlyerAlarmOptions"
                      value={entity.getIsCustomFlyerAlarmOptions()}
                      meta={entity.getIsCustomFlyerAlarmOptionsMetaInformation()}
                      validation={entity.getIsCustomFlyerAlarmOptionsValidationResult()}
                      onChange={this.changeEntity}
                      options={[{ value: false, label: messages.no }, { value: true, label: messages.yes }]}
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p>{messages.type}</p>
                  <div>
                    {['select', 'html', 'checkbox', 'text', 'colors', 'number', 'boolean', 'date'].map((type, i) => {
                      return (
                        <div class="m-b-20" key={i}>
                          <div class="radio radio-success m-b-0" key={i}>
                            <input
                              disabled={disabled}
                              id={'attributeType' + i}
                              name="type"
                              type="radio"
                              value={type}
                              checked={this.isTypeChecked(type)}
                              onChange={this.typeChange}
                            />
                            <label for={'attributeType' + i}>{messages.attributeName[type]}</label>
                          </div>
                          {messages.attributeType[type] ? (
                            <div class="p-l-25">
                              <p class="hint-text fs-13">{messages.attributeType[type]}</p>
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
AttributeData.defaultProps = {
  inModal: false,
};

export default injectIntl(AttributeData);
